/* ============================================================
   BD - LittleLoca Premium Slideshow JS
   File: assets/bd-slideshow.js
   Author: Biswarup Das
   ============================================================ */

(function () {
  'use strict';

  function initSlideshow(el) {
    const id       = el.id.replace('bd-ss-', '');
    const track    = document.getElementById('bd-ss-track-' + id);
    const slides   = el.querySelectorAll('.bd-ss__slide');
    const dots     = el.querySelectorAll('.bd-ss__dot');
    const prevBtn  = document.getElementById('bd-ss-prev-' + id);
    const nextBtn  = document.getElementById('bd-ss-next-' + id);
    const autoplay = el.dataset.autoplay === 'true';
    const delay    = parseInt(el.dataset.delay) || 5000;
    const total    = slides.length;

    if (!track || total === 0) return;

    let current   = 0;
    let timer     = null;
    let touchSX   = 0;
    let touchEX   = 0;

    /* GO TO */
    function goTo(i) {
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      current = i;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
    }

    /* AUTOPLAY */
    function start() {
      if (!autoplay || total <= 1) return;
      stop();
      timer = setInterval(function () { goTo(current + 1); }, delay);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    /* ARROWS */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); start(); });

    /* DOTS */
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.dataset.index)); start(); });
    });

    /* HOVER PAUSE */
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);

    /* SWIPE */
    el.addEventListener('touchstart', function (e) {
      touchSX = e.changedTouches[0].screenX;
      stop();
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      touchEX = e.changedTouches[0].screenX;
      if (Math.abs(touchSX - touchEX) > 50) {
        touchSX > touchEX ? goTo(current + 1) : goTo(current - 1);
      }
      start();
    }, { passive: true });

    /* KEYBOARD */
    el.setAttribute('tabindex', '0');
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(current - 1); start(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); start(); }
    });

    goTo(0);
    start();
  }

  /* INIT ALL */
  function initAll() {
    document.querySelectorAll('.bd-ss').forEach(initSlideshow);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  document.addEventListener('shopify:section:load', function (e) {
    const ss = e.target.querySelector('.bd-ss');
    if (ss) initSlideshow(ss);
  });

})();